import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import PopularGamesSection from './components/PopularGamesSection';
import FAQSection from './components/FAQSection';
import DownloadCTASection from './components/DownloadCTASection';
import StatsSection from './components/StatsSection';
import ArticleHighlightsSection from './components/ArticleHighlightsSection';

const organizationSchema = {
  name: 'NG南宫',
  url: 'https://ngnangong.com',
  description: 'NG南宫官方正版APP下载平台，提供最新版本iOS/Android安装包，安全无病毒，一键下载即玩。',
  sameAs: ['https://weibo.com/ngnangong', 'https://weixin.qq.com/ngnangong'],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-8888',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  name: 'NG南宫官方下载平台',
  url: 'https://ngnangong.com',
  description: 'NG南宫下载链接官方入口，提供最新版本iOS/Android安装包。',
  inLanguage: 'zh-CN',
};

const webpageSchema = {
  name: 'NG南宫 - 首页',
  description: 'NG南宫下载链接官方入口，提供最新版本iOS/Android安装包，安全无病毒，一键下载即玩。',
  url: 'https://ngnangong.com/',
  isPartOf: { '@id': 'https://ngnangong.com/#website' },
  about: { '@id': 'https://ngnangong.com/#organization' },
};

const faqSchema = {
  mainEntity: [
    {
      '@type': 'Question',
      name: 'NG南宫APP在哪里下载？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过NG南宫官方网站下载页面，选择iOS或Android版本进行下载。iOS用户可跳转至App Store安装，Android用户可直接下载APK安装包。',
      },
    },
    {
      '@type': 'Question',
      name: 'NG南宫APP是否免费下载？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，NG南宫APP完全免费下载安装。平台上的基础游戏均可免费畅玩。',
      },
    },
    {
      '@type': 'Question',
      name: 'NG南宫支持哪些设备平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'NG南宫全面支持iOS（iPhone/iPad）、Android手机和平板设备，部分游戏还提供PC桌面版客户端。',
      },
    },
    {
      '@type': 'Question',
      name: '下载安装过程安全吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'NG南宫所有安装包均经过多重安全检测和国际权威安全认证，不含任何病毒、恶意软件或捆绑程序。',
      },
    },
    {
      '@type': 'Question',
      name: '如何获取最新版本的NG南宫APP？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '打开已安装的NG南宫APP，系统会自动检测并提示更新。您也可以定期访问NG南宫官网下载页面手动更新。',
      },
    },
    {
      '@type': 'Question',
      name: '安装过程中遇到问题怎么办？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以查看下载教程页面获取详细指导，或联系7×24小时在线客服团队。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="WebPage" data={webpageSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <PopularGamesSection />
        <StatsSection />
        <ArticleHighlightsSection />
        <FAQSection />
        <DownloadCTASection />
      </main>

      <Footer />
    </>
  );
}